import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { ConfiguratorActions } from '../constants/configurator/configurator_actions';
import { Filters } from '../constants/filter/filters';
import { getDefaultValueForFilter } from '../helper/filters/get_default_value_for_filter';
import { types as productTypes } from '../../_constants/product/types';
import { forOwn } from '../../../lib/utilities';

class CatalogFilterStoreClass extends ReduceStore {
    getInitialState() {
        const values = {};
        values[Filters.WIDTH] = getDefaultValueForFilter(Filters.WIDTH);
        values[Filters.HEIGHT] = getDefaultValueForFilter(Filters.HEIGHT);
        values[Filters.DIAMETER] = getDefaultValueForFilter(Filters.DIAMETER);
        values[Filters.SPEED_INDEX] = getDefaultValueForFilter(Filters.SPEED_INDEX);
        values[Filters.LOAD_INDEX] = getDefaultValueForFilter(Filters.LOAD_INDEX);
        values[Filters.POSTCODE] = getDefaultValueForFilter(Filters.POSTCODE);
        values[Filters.USAGE] = getDefaultValueForFilter(Filters.USAGE);
        values[Filters.VEHICLE_TYPE] = getDefaultValueForFilter(Filters.VEHICLE_TYPE);
        values[Filters.RUN_FLAT] = getDefaultValueForFilter(Filters.RUN_FLAT);
        values[Filters.FREE_FITTING] = getDefaultValueForFilter(Filters.FREE_FITTING);
        values[Filters.BUY_4_PAY_3] = getDefaultValueForFilter(Filters.BUY_4_PAY_3);
        values[Filters.CLEARANCE] = getDefaultValueForFilter(Filters.CLEARANCE);
        values[Filters.TECHNOLOGY] = getDefaultValueForFilter(Filters.TECHNOLOGY);
        values[Filters.LABEL_NOISE] = getDefaultValueForFilter(Filters.LABEL_NOISE);
        values[Filters.LABEL_WET_GRIP] = getDefaultValueForFilter(Filters.LABEL_WET_GRIP);
        values[Filters.LABEL_FUEL_EFFICIENCY] = getDefaultValueForFilter(Filters.LABEL_FUEL_EFFICIENCY);
        values[Filters.UTQG_TREADWEAR_GROUP] = getDefaultValueForFilter(Filters.UTQG_TREADWEAR_GROUP);
        values[Filters.UTQG_TRACTION] = getDefaultValueForFilter(Filters.UTQG_TRACTION);
        values[Filters.UTQG_TEMPERATURE] = getDefaultValueForFilter(Filters.UTQG_TEMPERATURE);
        values[Filters.SEASON] = getDefaultValueForFilter(Filters.SEASON);
        values[Filters.EV] = getDefaultValueForFilter(Filters.EV);

        values[Filters.CUSTOMER_REVIEW_DRY_TRACTION_RATING_AVG_GROUP] = getDefaultValueForFilter(Filters.CUSTOMER_REVIEW_DRY_TRACTION_RATING_AVG_GROUP);
        values[Filters.CUSTOMER_REVIEW_LOW_NOISE_RATING_AVG_GROUP] = getDefaultValueForFilter(Filters.CUSTOMER_REVIEW_LOW_NOISE_RATING_AVG_GROUP);
        values[Filters.CUSTOMER_REVIEW_RIDE_COMFORT_RATING_AVG_GROUP] = getDefaultValueForFilter(Filters.CUSTOMER_REVIEW_RIDE_COMFORT_RATING_AVG_GROUP);
        values[Filters.CUSTOMER_REVIEW_STEERING_RESPONSE_RATING_AVG_GROUP] = getDefaultValueForFilter(Filters.CUSTOMER_REVIEW_STEERING_RESPONSE_RATING_AVG_GROUP);
        values[Filters.CUSTOMER_REVIEW_TREAD_WEAR_RATING_AVG_GROUP] = getDefaultValueForFilter(Filters.CUSTOMER_REVIEW_TREAD_WEAR_RATING_AVG_GROUP);
        values[Filters.CUSTOMER_REVIEW_VALUE_FOR_MONEY_RATING_AVG_GROUP] = getDefaultValueForFilter(Filters.CUSTOMER_REVIEW_VALUE_FOR_MONEY_RATING_AVG_GROUP);
        values[Filters.CUSTOMER_REVIEW_WET_TRACTION_RATING_AVG_GROUP] = getDefaultValueForFilter(Filters.CUSTOMER_REVIEW_WET_TRACTION_RATING_AVG_GROUP);

        values[Filters.DISCOUNT_INSTANT_CASH_50] = getDefaultValueForFilter(Filters.DISCOUNT_INSTANT_CASH_50);
        values[Filters.DISCOUNT_INSTANT_CASH_80] = getDefaultValueForFilter(Filters.DISCOUNT_INSTANT_CASH_80);
        values[Filters.DISCOUNT_INSTANT_CASH_100] = getDefaultValueForFilter(Filters.DISCOUNT_INSTANT_CASH_100);
        values[Filters.DISCOUNT_INSTANT_CASH_120] = getDefaultValueForFilter(Filters.DISCOUNT_INSTANT_CASH_120);
        values[Filters.DISCOUNT_INSTANT_CASH_150] = getDefaultValueForFilter(Filters.DISCOUNT_INSTANT_CASH_150);
        values[Filters.DISCOUNT_INSTANT_CASH_160] = getDefaultValueForFilter(Filters.DISCOUNT_INSTANT_CASH_160);
        values[Filters.DISCOUNT_INSTANT_CASH_200] = getDefaultValueForFilter(Filters.DISCOUNT_INSTANT_CASH_200);
        values[Filters.DISCOUNT_INSTANT_CASH_250] = getDefaultValueForFilter(Filters.DISCOUNT_INSTANT_CASH_250);
        values[Filters.DISCOUNT_INSTANT_CASH_300] = getDefaultValueForFilter(Filters.DISCOUNT_INSTANT_CASH_300);
        values[Filters.DISCOUNT_5_OFF] = getDefaultValueForFilter(Filters.DISCOUNT_5_OFF);
        values[Filters.DISCOUNT_10_OFF] = getDefaultValueForFilter(Filters.DISCOUNT_10_OFF);
        values[Filters.DISCOUNT_15_OFF] = getDefaultValueForFilter(Filters.DISCOUNT_15_OFF);
        values[Filters.DISCOUNT_20_OFF] = getDefaultValueForFilter(Filters.DISCOUNT_20_OFF);
        values[Filters.DISCOUNT_25_OFF] = getDefaultValueForFilter(Filters.DISCOUNT_25_OFF);
        values[Filters.PROMO_GIFT_CARD_50] = getDefaultValueForFilter(Filters.PROMO_GIFT_CARD_50);
        values[Filters.PROMO_GIFT_CARD_80] = getDefaultValueForFilter(Filters.PROMO_GIFT_CARD_80);
        values[Filters.PROMO_GIFT_CARD_100] = getDefaultValueForFilter(Filters.PROMO_GIFT_CARD_100);
        values[Filters.PROMO_GIFT_CARD_130] = getDefaultValueForFilter(Filters.PROMO_GIFT_CARD_130);
        values[Filters.PROMO_GIFT_CARD_150] = getDefaultValueForFilter(Filters.PROMO_GIFT_CARD_150);
        values[Filters.PROMO_GIFT_CARD_200] = getDefaultValueForFilter(Filters.PROMO_GIFT_CARD_200);
        values[Filters.PROMO_GIFT_CARD_250] = getDefaultValueForFilter(Filters.PROMO_GIFT_CARD_250);

        values[Filters.QUALITY_SEGMENT_PREMIUM] = getDefaultValueForFilter(Filters.QUALITY_SEGMENT_PREMIUM);
        values[Filters.QUALITY_SEGMENT_VALUE] = getDefaultValueForFilter(Filters.QUALITY_SEGMENT_VALUE);
        values[Filters.QUALITY_SEGMENT_BUDGET] = getDefaultValueForFilter(Filters.QUALITY_SEGMENT_BUDGET);
        const backupValues = {};
        return {
            visible: false,
            firstLayerVisible: false,
            infoLayerVisible: false,
            provideSizeMessage: '',
            provideIndexMessage: '',
            postcodeInvalidMessage: false,
            loadingOutOfStockCheck: '',
            outOfStock: '',
            values,
            backupValues,
            tyreIndexVisible: true,
            tyreIndexLinkVisible: true,
            configuratorType: productTypes.TYRE_CAR,
            pageOriginType: productTypes.TYRE_CAR,
            sectionVisibility: {
                sizes: true,
                indexes: true,
                postcode: true,
            },
            postcodeSuggestion: null,
            touched:false,
        };
    }

    reduce(state, { source, action }) {
        if (source === ACTION_TYPES.CATALOG_CONFIGURATOR_ACTION) {
            switch (action.type) {
                case ConfiguratorActions.SHOW_ACTION:
                    this.handleShowAction(state);
                    break;
                case ConfiguratorActions.SHOW_EXTENDED_ACTION:
                    this.handleShowExtendedAction(state, action.payload);
                    break;
                case ConfiguratorActions.HIDE_ACTION:
                    this.handleHideAction(state);
                    break;
                case ConfiguratorActions.SHOW_FIRST_LAYER:
                    this.handleShowFirstLayerAction(state);
                    break;
                case ConfiguratorActions.SHOW_SECOND_LAYER:
                    this.handleShowSecondLayerAction(state);
                    break;
                case ConfiguratorActions.SHOW_INFO_LAYER:
                    this.handleShowInfoLayerAction(state);
                    break;
                case ConfiguratorActions.HIDE_INFO_LAYER:
                    this.handleHideInfoLayerAction(state);
                    break;
                case ConfiguratorActions.SHOW_INFO_POSTCODE_INVALID:
                    this.handleShowPostcodeInvalidAction(state);
                    break;
                case ConfiguratorActions.HIDE_POSTCODE_INVALID:
                    this.handleHidePostcodeInvalidAction(state);
                    break;
                case ConfiguratorActions.SET_WIDTH:
                    this.handleSetWidthAction(state, action.payload);
                    break;
                case ConfiguratorActions.SET_HEIGHT:
                    this.handleSetHeightAction(state, action.payload);
                    break;
                case ConfiguratorActions.SET_DIAMETER:
                    this.handleSetDiameterAction(state, action.payload);
                    break;
                case ConfiguratorActions.SET_SPEED_INDEX:
                    this.handleSetSpeedIndexAction(state, action.payload);
                    break;
                case ConfiguratorActions.SET_LOAD_INDEX:
                    this.handleSetLoadIndexAction(state, action.payload);
                    break;
                case ConfiguratorActions.SET_POSTCODE:
                    this.handleSetPostcodeAction(state, action.payload);
                    break;
                case ConfiguratorActions.SET_VALUES:
                    this.handleSetValuesAction(state, action.payload);
                    break;
                case ConfiguratorActions.SET_BACKUP_VALUES:
                    this.handleSetBackupValuesAction(state, action.payload);
                    break;
                case ConfiguratorActions.SET_VISIBLE_SECTIONS:
                    this.handleSetVisibleSectionsAction(state, action.payload);
                    break;
                case ConfiguratorActions.SET_OUT_OF_STOCK_CHECK_LOADING:
                    this.handleSetOutOfStockLoadingAction(state, action.payload);
                    break;
                case ConfiguratorActions.SET_OUT_OF_STOCK_CHECK_LOADING_DONE:
                    this.handleSetOutOfStockLoadingDoneAction(state, action.payload);
                    break;
                case ConfiguratorActions.SET_OUT_OF_STOCK:
                    this.handleSetOutOfStockAction(state, action.payload);
                    break;
                case ConfiguratorActions.SET_IN_STOCK:
                    this.handleSetInStockAction(state, action.payload);
                    break;
                case ConfiguratorActions.SHOW_TYRE_INDEX:
                    this.handleShowTyreIndexAction(state);
                    break;
                case ConfiguratorActions.HIDE_TYRE_INDEX:
                    this.handleHideTyreIndexAction(state);
                    break;
                case ConfiguratorActions.SHOW_TYRE_INDEX_LINK:
                    this.handleShowTyreIndexLinkAction(state);
                    break;
                case ConfiguratorActions.HIDE_TYRE_INDEX_LINK:
                    this.handleHideTyreIndexLinkAction(state);
                    break;
                case ConfiguratorActions.SET_CONFIGURATOR_TYPE:
                    this.handleSetConfiguratorType(state, action.payload);
                    break;
                case ConfiguratorActions.SET_PAGE_ORIGIN_TYPE:
                    this.handleSetPageOriginType(state, action.payload);
                    break;
                case ConfiguratorActions.SET_POSTCODE_SUGGESTION:
                    state.postcodeSuggestion = action.payload;
                    state.postcodeInvalidMessage = false;
                    this.__emitChange();
                    break;
                default:
                    return false;
            }
        }

        return state;
    }

    handleShowAction(state) {
        this.clearExtendedValuesAction(state);
        if (!state.visible) {
            state.visible = true;
        }

        this.__emitChange();
    }

    handleShowExtendedAction(state, payload) {
        this.clearExtendedValuesAction(state);
        if (!state.visible) {
            state.visible = true;
            $.each(payload, function (i, v) {
                state.values[i] = v;
            });
        }

        this.__emitChange();
    }

    clearExtendedValuesAction(state) {
        state.values[Filters.USAGE] = '';
        state.values[Filters.VEHICLE_TYPE] = '';
        state.values[Filters.RUN_FLAT] = '';
        state.values[Filters.FREE_FITTING] = '';
        state.values[Filters.BUY_4_PAY_3] = '';
        state.values[Filters.CLEARANCE] = '';
        state.values[Filters.TECHNOLOGY] = '';
        state.values[Filters.UTQG_TREADWEAR_GROUP] = '';
        state.values[Filters.UTQG_TRACTION] = '';
        state.values[Filters.UTQG_TEMPERATURE] = '';
        state.values[Filters.SEASON] = '';
        state.values[Filters.EV] = '';
        state.values[Filters.CUSTOMER_REVIEW_DRY_TRACTION_RATING_AVG_GROUP] = '';
        state.values[Filters.CUSTOMER_REVIEW_LOW_NOISE_RATING_AVG_GROUP] = '';
        state.values[Filters.CUSTOMER_REVIEW_RIDE_COMFORT_RATING_AVG_GROUP] = '';
        state.values[Filters.CUSTOMER_REVIEW_STEERING_RESPONSE_RATING_AVG_GROUP] = '';
        state.values[Filters.CUSTOMER_REVIEW_TREAD_WEAR_RATING_AVG_GROUP] = '';
        state.values[Filters.CUSTOMER_REVIEW_VALUE_FOR_MONEY_RATING_AVG_GROUP] = '';
        state.values[Filters.CUSTOMER_REVIEW_WET_TRACTION_RATING_AVG_GROUP] = '';

        state.values[Filters.DISCOUNT_INSTANT_CASH_50] = '';
        state.values[Filters.DISCOUNT_INSTANT_CASH_80] = '';
        state.values[Filters.DISCOUNT_INSTANT_CASH_100] = '';
        state.values[Filters.DISCOUNT_INSTANT_CASH_120] = '';
        state.values[Filters.DISCOUNT_INSTANT_CASH_150] = '';
        state.values[Filters.DISCOUNT_INSTANT_CASH_160] = '';
        state.values[Filters.DISCOUNT_INSTANT_CASH_200] = '';
        state.values[Filters.DISCOUNT_INSTANT_CASH_250] = '';
        state.values[Filters.DISCOUNT_INSTANT_CASH_300] = '';
        state.values[Filters.DISCOUNT_5_OFF] = '';
        state.values[Filters.DISCOUNT_10_OFF] = '';
        state.values[Filters.DISCOUNT_15_OFF] = '';
        state.values[Filters.DISCOUNT_20_OFF] = '';
        state.values[Filters.DISCOUNT_25_OFF] = '';
        state.values[Filters.PROMO_GIFT_CARD_50] = '';
        state.values[Filters.PROMO_GIFT_CARD_80] = '';
        state.values[Filters.PROMO_GIFT_CARD_100] = '';
        state.values[Filters.PROMO_GIFT_CARD_130] = '';
        state.values[Filters.PROMO_GIFT_CARD_150] = '';
        state.values[Filters.PROMO_GIFT_CARD_200] = '';
        state.values[Filters.PROMO_GIFT_CARD_250] = '';

        state.values[Filters.QUALITY_SEGMENT_PREMIUM] = '';
        state.values[Filters.QUALITY_SEGMENT_VALUE] = '';
        state.values[Filters.QUALITY_SEGMENT_BUDGET] = '';
    }

    handleHideAction(state) {
        if (state.visible) {
            state.visible = false;
            this.__emitChange();
        }
    }

    handleShowFirstLayerAction(state) {
        if (!state.firstLayerVisible) {
            state.firstLayerVisible = true;
            this.__emitChange();
        }
    }

    handleShowSecondLayerAction(state) {
        if (state.firstLayerVisible || state.infoLayerVisible) {
            state.firstLayerVisible = false;
            state.infoLayerVisible = false;
            this.__emitChange();
        }
    }

    handleShowInfoLayerAction(state) {
        if (!state.infoLayerVisible) {
            state.infoLayerVisible = true;
            this.__emitChange();
        }
    }

    handleHideInfoLayerAction(state) {
        if (state.infoLayerVisible) {
            state.infoLayerVisible = false;
            this.__emitChange();
        }
    }

    handleShowPostcodeInvalidAction(state) {
        if (!state.postcodeInvalidMessage) {
            state.postcodeInvalidMessage = true;
            this.__emitChange();
        }
    }

    handleHidePostcodeInvalidAction(state) {
        if (state.postcodeInvalidMessage) {
            state.postcodeInvalidMessage = false;
            this.__emitChange();
        }
    }

    handleSetWidthAction(state, payload) {
        if (state.values[Filters.WIDTH] !== payload) {
            state.values[Filters.WIDTH] = payload;
            this.__emitChange();
        }
    }

    handleSetHeightAction(state, payload) {
        if (state.values[Filters.HEIGHT] !== payload) {
            state.values[Filters.HEIGHT] = payload;
            this.__emitChange();
        }
    }

    handleSetDiameterAction(state, payload) {
        if (state.values[Filters.DIAMETER] !== payload) {
            state.values[Filters.DIAMETER] = payload;
            this.__emitChange();
        }
    }

    handleSetSpeedIndexAction(state, payload) {
        if (state.values[Filters.SPEED_INDEX] !== payload) {
            state.values[Filters.SPEED_INDEX] = payload;
            this.__emitChange();
        }
    }

    handleSetLoadIndexAction(state, payload) {
        if (state.values[Filters.LOAD_INDEX] !== payload) {
            state.values[Filters.LOAD_INDEX] = payload;
            this.__emitChange();
        }
    }

    handleSetPostcodeAction(state, payload) {
        if (state.values[Filters.POSTCODE] !== payload) {
            state.values[Filters.POSTCODE] = payload;
            state.touched = true;
            this.__emitChange();
        }
    }

    handleSetValuesAction(state, payload) {
        let change = false;

        forOwn(payload, (value, key) => {
            if (typeof state.values[key] !== 'undefined' && payload[key] !== state.values[key]) {
                state.values[key] = payload[key];
                change = true;
            }
        });

        if (change) {
            this.__emitChange();
        }
    }

    handleSetBackupValuesAction(state, payload) {
        let change = false;
        forOwn(payload, (value, key) => {
            if (payload[key] !== state.backupValues[key]) {
                state.backupValues[key] = payload[key];
                change = true;
            }
        });

        if (change) {
            this.__emitChange();
        }
    }

    handleSetVisibleSectionsAction(state, payload) {
        forOwn(state.sectionVisibility, (curVisiblity, sectionName) => {
            state.sectionVisibility[sectionName] = false;
        });

        payload.forEach(section => {
            if (typeof state.sectionVisibility[section] !== 'undefined') {
                state.sectionVisibility[section] = true;
            }
        });

        this.__emitChange();
    }

    handleSetOutOfStockLoadingAction(state, filterNameToBeChecked) {
        if (state.loadingOutOfStockCheck !== filterNameToBeChecked) {
            state.loadingOutOfStockCheck = filterNameToBeChecked;
            this.__emitChange();
        }
    }

    handleSetOutOfStockLoadingDoneAction(state) {
        if (state.loadingOutOfStockCheck) {
            state.loadingOutOfStockCheck = '';
            this.__emitChange();
        }
    }

    handleSetOutOfStockAction(state, payload) {
        if (state.outOfStock !== payload) {
            state.outOfStock = payload;
            this.__emitChange();
        }
    }

    handleSetInStockAction(state) {
        if (state.outOfStock) {
            state.outOfStock = '';
            this.__emitChange();
        }
    }

    handleShowTyreIndexAction(state) {
        if (!state.tyreIndexVisible) {
            state.tyreIndexVisible = true;
            this.__emitChange();
        }
    }

    handleHideTyreIndexAction(state) {
        if (state.tyreIndexVisible) {
            state.tyreIndexVisible = false;
            this.__emitChange();
        }
    }

    handleSetConfiguratorType(state, payload) {
        if (state.configuratorType !== payload) {
            state.configuratorType = payload;
            this.__emitChange();
        }
    }

    handleSetPageOriginType(state, payload) {
        if (state.pageOriginType !== payload) {
            state.pageOriginType = payload;
            this.__emitChange();
        }
    }

    handleShowTyreIndexLinkAction(state) {
        if (!state.tyreIndexLinkVisible) {
            state.tyreIndexLinkVisible = true;
            this.__emitChange();
        }
    }

    handleHideTyreIndexLinkAction(state) {
        if (state.tyreIndexLinkVisible) {
            state.tyreIndexLinkVisible = false;
            this.__emitChange();
        }
    }
}

const CatalogFilterStore = new CatalogFilterStoreClass(Dispatcher);
export default CatalogFilterStore;
